<template lang="">
  <div>
    <div class="index">
      <Banner />
      <div class="search_view">
        <div class="search_view-l">
          搜索关键词：光学PC薄膜、透明PC薄膜、磨砂PC薄膜、阻燃PC薄膜、箱包PC薄膜等
        </div>
        <div class="search_view-r">
          <input placeholder="请输入关键词" v-model="keyword">
          <button class="btn keyword_search_btn" @click="search(keyword)"> <i class="iconfont icon-search"></i></button>
        </div>
      </div>
      <div class="index-card index-hot" v-if="showHot.length>0">
        <div class="card-title ">
          <div class="l">热门产品<span>PRODUCT</span></div>
        </div>
        <div class="index-hot-item">
          <div class="container">
            <div class="item-pic">
              <img :src="showHot[0].image_url" />
            </div>
            <div class="item-main">
              <div class="item-title">{{showHot[0].name}}</div>
              <div class="item-desc" v-html="showHot[0].description">
              </div>
              <div class="item-labels">
                <router-link :to="{name:'products',query:{category_id:item.parent_id}}"
                  v-for="(item,index) in productCategory" :key="index">{{item.parent_name}}<span
                    class="iconfont icon-next1"></span></router-link>
              </div>
              <router-link class="more" :to="{name:'productDetail',params:{id:showHot[0].id}}">查看更多 <span
                  class="iconfont icon-next"></span></router-link>
            </div>
          </div>
        </div>
        <div class="index-hot-item index-hot-item2" v-if="showHot.length>1">
          <div class="container">
            <div class="item-main">
              <div class="item-title">{{showHot[1].name}}</div>
              <div class="item-desc" v-html="showHot[1].description">
              </div>

              <router-link class="more" :to="{name:'productDetail',params:{id:showHot[1].id}}">查看更多 <span
                  class="iconfont icon-next"></span></router-link>
            </div>
            <div class="item-pic">
              <img :src="showHot[1].image_url" />
            </div>
          </div>
        </div>
      </div>
      <div class="index-card">
        <div class="card-title container">
          <div class="l">应用领域<span>COOPERATE</span></div>
        </div>
        <div class="tabs">
          <ul class="tab-titles">
            <li :class="{'tab-title':true, active:activeTab===index}" @mouseover="activeTab=index"
              v-for="(item,index) in category" :key="index">{{item.name}}</li>
          </ul>
          <div class="tab-content container">
            <div class="child" :class="{show:activeTab==index}" v-for="(group,index) in category">
              <ul class="list_view">
                <li v-for="(groupItem) in group.content">
                  <a href="#">
                    <div class="item-pic">
                      <img :src="groupItem.image_url" alt="">
                    </div>
                    <div class="item-main">
                      <div class="item-text">{{groupItem.title}}</div>
                    </div>
                  </a>
                </li>
              </ul>
            </div>
          </div>

        </div>
      </div>
      <div class="index-card index-about">
        <div class="card-title container">
          <div class="l">关于达孚<span>INTRODUCE</span></div>
        </div>
        <div class="company_view container" v-if="profileList.length>0">
          <div class="l">
            <div>
              <div class="company-name"> <span></span>{{profileList[0].title}}</div>
              <div class="company-desc" v-html="profileList[0].content">
              </div>
            </div>
            <!-- <div class="company-numbers">
              <div class="numbers-item">
                <div class="item-num"><span id="company-invest">{{profileList[0].output}}</span>亿</div>
                <div class="item-name">年产值</div>
              </div>
              <span class="num-line"></span>
              <div class="numbers-item">
                <div class="item-num"><span id="company-area"> {{profileList[0].area}}</span><span>㎡</span></div>
                <div class="item-name">厂房面积</div>
              </div>
              <span class="num-line"></span>
              <div class="numbers-item">
                <div class="item-num"><span id="company-make">
                    {{profileList[0].product}}</span></span><span>吨/年</span></div>
                <div class="item-name">生产能力</div>
              </div>
            </div> -->
          </div>
          <div class="r video-item">
            <div class="videoGroup" style="height:100% /*375px*/;">
              <!-- <div class="playBtnBG" @click="play">
                <img class="playBtn" :src="playBtnSrc" ref="playBtn">
              </div> -->
              <!-- <video class="item-video" id="dfvideo" ref="videoPlayer" :style="{zIndex:videoZIndex}"
                src="https://video-1251283048.cos.ap-guangzhou.myqcloud.com/cailongIntroductionVideo/DaFuuInProductVideo.mp4"
                controls></video> -->
              <iframe style="z-index: 1;" class="item-video" id="dfvideo" ref="videoPlayer"
                :src="profileList[0].video_url" scrolling="no" border="0" frameborder="no"
                framespacing="0" allowfullscreen="true">
              </iframe>
              <!-- <iframe height=498 width=510 src='https://player.youku.com/embed/XNTkxNTMyMjM4MA==' frameborder=0 'allowfullscreen'></iframe> -->
            </div>
          </div>
        </div>
        <div class="container">
          <div class="index-partners">
            <img src="../assets/imgs/index-partners.png" alt="">
          </div>
        </div>
      </div>
      <div class="index-advantage">
        <div class="advantage-list container">
          <div class="list-item" v-for="(item,index) in advantage" :key="index">
            <div class="item-icon">
              <img :src="item.image_url" alt="">
            </div>
            <div class="item-text" v-html="item.content">
            </div>
          </div>
        </div>
      </div>
      <div class="index-card index-research">
        <div class="card-title container">
          <div class="l">研发中心<span>RESEARCH</span></div>
        </div>
        <div class="home_advantage std_padding1  container">
          <div class="ys_cont1440">
            <div class="mod_title1 ">
              <!-- 所有std_title2 有on代表有前面的装饰，没有on没有装饰 -->
            </div>
            <div class="home_advantage_cry">
              <div class="home_advantage_cry_circle wow ys_fadeup3"
                style="visibility: visible; animation-name: ysfadeInUp;">
                <div class="hacc_out">
                  <div class="hacc_dotted">
                    <img src="../assets/imgs/a1_dashed.svg" alt="">
                  </div>
                  <div class="hacc_logo">
                    <img src="../assets/imgs/head_logo.png" style="width: 60%;" alt="head_logo">
                  </div>
                  <div id="hacc_circle">
                    <svg width="128" height="128" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle id="circle" cx="50%" cy="50%" r="calc(50% - 2px)" stroke-width="4" stroke="#1656D2"
                        fill="none" :stroke-dasharray="strokeDasharray" :stroke-dashoffset="storkeDashoffset"></circle>
                    </svg>
                  </div>
                   <ul class="hacc_list">
                    <li v-for="(item,index) in rdCenterList" :key="index"
                     :class="['hacc_list_nub', 'hacc_list_nub' + (index + 1), { on: selectedIndex === index }]" 
                     @click="showPic(index)" @mouseover="showPic(index)" >
                      <div class="hacc_list_nub_icon">
                        <div class="hacc_icon_img ys_imgbox_cover">
                          <img :src="item.icon_on" alt="icon02.svg">
                          <img :src="item.icon_off" alt="icon021.svg">
                        </div>
                        <div class="hacc_icon_font">{{item.title}}</div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div class="r">
              <div class="r-title">{{ selectedTitle }}</div>
              <div class="r-pic">
                <img :src="selectedPic" alt="">
              </div>
            </div>
          </div>
        </div>

        <div class="index-research-body container">
          <div class="title">产品质量控制流程</div>
          <div class="research_banner swiper-container-initialized swiper-container-horizontal">
            <swiper :options="researchSwiperOptions">
              <swiper-slide class="swiper-slide" v-for="(item,index) in controlList" :key="index">
                <img :src="item.image_url" alt="">
                <span class="zlbktext">{{item.title}}</span>
              </swiper-slide>
            </swiper>
          </div>
        </div>
      </div>
      <div class="index-card index-news">
        <div class="card-title container">
          <div class="l">企业资讯<span>NEWS</span></div>
          <router-link class="more" to="/news">查看更多 <span class="iconfont icon-next"></span></router-link>
        </div>
        <div class="index-news-list container">
          <router-link class="new-item" :to="{name:getRouteName(item.category_id),params:{id:item.id}}"
            v-for="(item,index) in newsList.slice(0,3)" :key="index">
            <div class="item-time"><span>{{item.create_time.day}}</span> {{item.create_time.month}} /
              {{item.create_time.year}}</div>
            <div class="item-title">{{item.title}}</div>
            <div class="item-pic">
              <img :src="item.image_url" alt="">
            </div>
            <!-- <div class="item-desc oneline">Faster charging speed means that the separator between the positive and
              negative electrodes needs to be...</div> -->
            <a class="item-more">
              查看详情 >
            </a>
          </router-link>
        </div>
      </div>
      <div class="index-card notes container">
        <div class="card-title">
          <div class="l">在线留言<span>NOTE</span></div>
        </div>
        <div class="notes-form container">
          <div class="two-input">
            <div class="form-input">
              <div class="form-input-label">
                <span class="iconfont icon-name"></span>
                <span>姓名：</span>
              </div>
              <div class="form-input-value">
                <input type="text" v-model="btnForm.name">
              </div>
            </div>
            <div class="form-input">
              <div class="form-input-label">
                <span class="iconfont icon-phone"></span>
                <span>电话(必填)：</span>
              </div>
              <div class="form-input-value">
                <input type="text" v-model="btnForm.phone">
              </div>
            </div>
          </div>
          <div class="form-input">
            <div class="form-input-label">
              <span class="iconfont icon-mail"></span>
              <span>邮箱：</span>
            </div>
            <div class="form-input-value">
              <input type="text" v-model="btnForm.email">
            </div>
          </div>
          <div class="form-textarea">
            <div class="form-input-label">
              <span class="iconfont icon-note"></span>
              <span>内容：</span>
            </div>
            <div class="form-textarea-value">
              <textarea name="" id="" cols="30" rows="4" v-model="btnForm.content"></textarea>
            </div>
          </div>
          <div class="form-submit" @click="btnSubmit()">
            免费索样</div>
        </div>
      </div>
    </div>

    <div id="backTop">
      <span class="iconfont icon-fanhuijiantou-copy"></span>
    </div>
  </div>
</template>
<script>
  import Banner from '../components/banner'
  export default {
    components: {
      Banner
    },
     computed: {
        selectedTitle() {
            return this.rdCenterList[this.selectedIndex].title;
        },
        selectedPic() {
            return this.rdCenterList[this.selectedIndex].pic;
        }
    },
    data() {
      return {
        strokeDasharray:1500,
        storkeDashoffset:1500,
        count:0,
        timeId:null,
        circleId:null,
        selectedIndex:0,
        keyword: '',
        showHot: [],
        applyList: [],
        category: [],
        activeTab: 0,
        profileList: [],
        advantage: [],
        controlList: [],
        newsList: [],
        btnForm: {},
        productCategory: [],
        rdCenterList:[],
        researchSwiperOptions: {
          speed: 6000,
          spaceBetween: 40,
          centeredSlides: true,
          watchSlidesProgress: true,
        },
        playBtnSrc: 'data:image/png;base64,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',
        videoZIndex: '-1'
      }
    },
    created() {
      this.getProduct();
      this.getApply();
      this.getProfile();
      this.getCore();
      this.getControl();
      this.getNews();
      this.getProductCate();
      this.getrdCenter();
    },
    mounted() {
      const video = this.$refs.videoPlayer;
      // video.addEventListener('ended', this.onVideoEnded);
      // this.$refs.playBtn.addEventListener('mouseenter', this.onMouseEnter);
      // this.$refs.playBtn.addEventListener('mouseleave', this.onMouseLeave);
      this.startTimer();
      this.startCircle()
    },
    beforeDestroy() {
      const video = this.$refs.videoPlayer;
      // video.removeEventListener('ended', this.onVideoEnded);
      // this.$refs.playBtn.removeEventListener('mouseenter', this.onMouseEnter);
      // this.$refs.playBtn.removeEventListener('mouseleave', this.onMouseLeave);
      this.stopTimer()
    },
    methods: {
      //定时器功能
      startTimer(){
       if(this.timeId){
          clearInterval(this.timeId)
       }
       this.timeId = setInterval(()=>{
          if (this.count>=5) {
            this.count=0
          }else{
            this.count++
          }
          this.showPic(this.count)
       },3000)
      },
      //圆环定时器
      startCircle(){
       this.circleId = setInterval(()=>{
          this.strokeDasharray+=150
        },2000)
      },
      //清除定时器
      stopTimer(){
       if (this.timeId) {
        clearInterval(this.timeId);
        clearInterval(this.circleId);
        this.circleId=null;
        this.timeId=null;
       }
      },
      showPic(index) {
            if (this.count!==index) {
               this.count=index
            }
            this.selectedIndex = index; // 更新选中的索引
            
        },
      //搜索功能
      search(keyword) {
        this.$router.push({
          path: "/products",
          query: {
            name: keyword
          }
        })
      },
      async getProductCate() {
        const res = await this.$request.get('productcategory/getPaginate')
        if (res.data.code === 0) {
          this.productCategory = res.data.data.data
          this.productCategory = this.productCategory.map(item => {
            return { parent_id: item.parent_id, parent_name: item.parentName }
          })
          this.productCategory = this.productCategory.reduce((acc, cur) => {
            if (!acc.some((item) => item.parent_id === cur.parent_id)) {
              acc.push(cur)
            }
            return acc;
          }, []);
        }
      },
      //获取热门产品
      async getProduct() {
        const res = await this.$request.get('product/getAll')
        if (res.data.code === 0) {
          this.showHot = res.data.data
          this.showHot = this.showHot.filter(item => item.is_hot === 1)
          this.showHot.forEach(item => {
            item.image_url = item.image_url.split(',')[0]
          })
        }
      },
      //获取应用领域信息
      async getApply() {
        const res = await this.$request.post('apply/getpaginate',{
          fil:true
        });
        if (res.data.code === 0) {
          this.applyList = res.data.data
          this.applyList = this.applyList.filter(item => item.is_show === 2)
          this.category = this.changeApply(this.applyList)
        }
      },
      //转换应用领域数据格式
      changeApply(arr) {
        // 使用reduce函数来分组
        const groupedByDomain = arr.reduce((groups, item) => {
          // 如果该domain（分类ID）的组不存在，则创建一个新组
          if (!groups[item.domain]) {
            groups[item.domain] = {
              name: item.name, // 分类名称
              content: [] // 初始化内容数组
            };
          }
          // 将当前项添加到对应domain（分类ID）的组中
          groups[item.domain].content.push(item);
          return groups;
        }, {});

        // 将分组后的对象数组化
        const result = Object.values(groupedByDomain);
        return result
      },
      //获取公司简介
      async getProfile() {
        const res = await this.$request.get('profile/getpaginate');
        if (res.data.code === 0) {
          this.profileList = res.data.data.data
        }
      },
      //获取研发中心
      async getrdCenter() {
        const res = await this.$request.get('Rdcenter/getpaginate');
        if (res.data.code === 0) {
          this.rdCenterList = res.data.data.data
        }
      },
      //获取核心优势
      async getCore() {
        const res = await this.$request.get('advantage/getpaginate');
        if (res.data.code === 0) {
          this.advantage = res.data.data.data
          this.advantage = this.advantage.filter(item => item.is_show === 1)
        }
      },
      //获取质量控制热门
      async getControl() {
        const res = await this.$request.get('control/getpaginate');
        if (res.data.code === 0) {
          this.controlList = res.data.data.data.filter(item => item.is_hot === 1)
        }
      },
      //获取企业资讯
      async getNews() {
        const res = await this.$request.post('News/getPaginate',{
          fil:2
        });
        if (res.data.code === 0) {
          this.newsList = res.data.data
          this.newsList = this.newsList.filter((item) => item.is_hot === 1 && item.is_show === 1)
        }
        //整理时间
        this.newsList.forEach((item, index) => {
          let obj = {};
          let time1 = item.create_time.split(' ');
          let time = time1[0].split('-');
          obj.year = time[0];
          obj.month = time[1];
          obj.day = time[2]
          item.create_time = obj
        })
      },
      //判断是哪个分类的资讯
      getRouteName(type){
         switch (type) {
          case 1:
            return 'newsDetail'
          case 2:
            return 'reportDetail'
          case 3:
            return 'exhibitionDetail'
          default:
            return 'newsDetail';
         }
      },
      //提交检索
      async btnSubmit() {
        this.loading = true;
        let res = await this.$request.post('online/add', this.btnForm)
        this.loading = false
        if (res.data.code === 0) {
          this.$message.success("提交成功")
        } else {
          this.$message.error("提交失败")
        }
      },
      //播放视频-----------------------------------------------------------
      play() {
        const video = this.$refs.videoPlayer;
        const playBtn = this.$refs.playBtn;

        if (video.paused) {
          video.play();
          playBtn.style.display = 'none'; // 点击后隐藏播放按钮
          this.videoZIndex = '1'; // 提升视频图层
        }
      },
      onVideoEnded() {
        this.videoZIndex = '-1'; // 播放完成后降低视频图栏
        this.$refs.playBtn.style.display = 'block';
      },
      onMouseEnter() {
        this.playBtnSrc = './images/imgs/PlayBtn2.png'; // 鼠标悬停时更改图片路径
      },
      onMouseLeave() {
        this.playBtnSrc = '/images/imgs/PlayBtn.png'; // 鼠标离开时恢复原始图片路径
      }
    },
    
  }
</script>
<style lang="scss" scoped>
  #circle{
    transition: all linear 3s;
  }
  .hacc_list_nub1{
   top:0%;
   left:50%;
  }
  .hacc_list_nub2{
top:25%;left:93.1%;
  }
  .hacc_list_nub3{
top:75%;left:93.1%;
  }
  .hacc_list_nub4{
top:100%;left:50%;
  }
  .hacc_list_nub5{
top:75%;left:6.9%
  }
  .hacc_list_nub6{
top:25%;left:6.9%;
  }
</style>